import { EventManager } from '../../core/index.js';

import { EventManagerContext } from './EventManagerContext.js';

export interface EventManagerProviderProps {
  children: React.ReactNode;
  events: EventManager;
}

/**
 * Provides the event manager to the application
 */
export const EventManagerProvider: React.FC<EventManagerProviderProps> = ({ children, events }) => {
  return <EventManagerContext.Provider value={events}>{children}</EventManagerContext.Provider>;
};
